const common = {
  search: 'Pesquisar...',
  select: 'Selecionar',
  selectDropdown: 'Selecionar...',
  loading: 'Carregando...',
  selected: '{{count}} selecionados ',
  noOptions: 'Sem opções',
  all: 'Tudo',
  allWithName: 'Tudo {{name}}',
  add: 'Adicionar',
  selectAll: 'Selecionar tudo',
  unselectAll: 'Desmarcar tudo',
  blank: 'Em branco',
  enter: 'Insira',
  items: '{{count}} itens, ',
  shortWeekdays: ['S', 'T', 'Q', 'Q', 'S', 'S', 'D'],
  distanceType: {
    metric: 'Km',
    imperial: 'Mi',
  },
  hour: 'Hora',
  reductions: {
    h: 'h',
    m: 'm',
    s: 's',
  },
  connectorStatus: {
    free: 'Disponível',
    busy: 'Indisponível',
    unknown: 'Desconhecido',
    error: 'Com falha',
  },
  yes: 'Sim',
  no: 'Não',
  weekDays: {
    sunday: 'domingo',
    monday: 'segunda-feira',
    tuesday: 'terça-feira',
    wednesday: 'quarta-feira',
    thursday: 'quinta-feira',
    friday: 'sexta-feira',
    saturday: 'sábado',
  },
  internal: 'Interno',
  google: 'Google',
  operationAddress: {
    student: 'Endereço do estudante',
    employee: 'Endereço do funcionário',
  },
  map: {
    zoomIn: 'Aproximar',
    zoomOut: 'Afastar',
    fullScreen: 'Tela cheia',
    measureDistance: 'Medir distância',
    polygon: {
      exceededModal: {
        body: 'A circunferência de uma zona "Bloco" não pode exceder 10 km',
        cancel: 'Cancelar',
      },
      deleteModal: {
        header: 'Excluir polígono?',
        body: 'Você está prestes a excluir o polígono',
      },
    },
  },
  roles: {
    dispatchadmin: 'Administrador de despacho',
    dispatcher: 'Despachante',
    superagent: 'Super Agente',
    agent: 'Agente',
    supplier: 'Fornecedor',
    superadmin: 'Super Administrador',
    accountingadmin: 'Administrador de Contabilidade',
    accountant: 'Contador',
    companyadmin: 'Administrador da empresa',
    admin: 'Administrador',
  },
  duration: 'Duração',
  distance: 'Distância',
};

export default common;
